var $44818ec984fbda74$exports = {};
$44818ec984fbda74$exports = {
    "breadcrumbs": `Popis cesty`
};


export {$44818ec984fbda74$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
